export const appTradeConfig = {
    isSecurityCheckPlaceOrder: false,
    isSecurityCheckTransaction: false,
    fullMode: false,
    needOTPCheck: false
}
export const gtdMarketIncludes = ['HKEX'];
